<template>
  <div class="maintenance" v-title.async="title">
    <p>系统升级中，若有不便，敬请谅解。</p>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',

  data() {
    return {
      title: '',
    }
  },

  mounted() {
    this.title = '系统升级中'
  },
}
</script>

<style scoped lang="scss">
.maintenance {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 14px;
}
</style>
